import React from 'react';
import MessageCourier from '../../../lib/MessageCourier';
import SystemClient from '../../../system/SystemClient';
import { PlanillaPartido } from '../../../system/PlanillaPartido/PlanillaPartido';
import PlanillaDigitalForm from '../PlanillaDigitalForm';
import DialogTemplate from '../../Common/DialogTemplate';
import { Icon, TextField } from '@fluentui/react';
import { PlanillaPartidoJugador } from '../../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import XhrRequestError from '../../../lib/XhrRequestError';

interface ICambioCamisetaDialog {
  form: PlanillaDigitalForm;
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  isPartidoOnline: boolean;
  showCambioCamiseta: boolean;
  showCambioCamisetaTeam: string;
  setShowCambioCamiseta: (v: boolean) => void;
  setShowCambioCamisetaTeam: (v: string) => void;
}

const CambioCamisetaDialog = ({
  form,
  system,
  courier,
  changeBlockUI,
  isPartidoOnline,
  showCambioCamiseta,
  showCambioCamisetaTeam,
  setShowCambioCamiseta,
  setShowCambioCamisetaTeam,
}: ICambioCamisetaDialog) => {
  const [oldCamiseta, setOldCamiseta] = React.useState<string>('');
  const [newCamiseta, setNewCamiseta] = React.useState<string>('');

  const camisetaExist = (camiseta: number) => {
    let ppjList: PlanillaPartidoJugador[] = [];
    if (showCambioCamisetaTeam === 'L') {
      ppjList = form.getPlanillaPartidoJugadorLocales();
    } else {
      ppjList = form.getPlanillaPartidoJugadorVisitantes();
    }
    return ppjList.some((ppj) => ppj.dorsalEs(camiseta));
  };

  const validateAccept = () => {
    return !(camisetaExist(+oldCamiseta) && oldCamiseta && !camisetaExist(+newCamiseta) && newCamiseta);
  };

  const clear = () => {
    setShowCambioCamiseta(false);
    setShowCambioCamisetaTeam('');

    setOldCamiseta('');
    setNewCamiseta('');
  };

  const onAccept = async () => {
    clear();
    const planillaPartido = form.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const eqId =
      showCambioCamisetaTeam === 'L' ? form.getEquipoLocal().getId() : form.getEquipoVisitante().getId();
    let ppj = planillaPartido
      .getPlanillaPartidoJugadorList()
      .find((ppj) => ppj.dorsalEs(oldCamiseta) && +ppj.getEqid() === +eqId!);
    ppj?.setDorsal(+newCamiseta);

    if (isPartidoOnline && ppj) {
      try {
        const savedPpj = await system.getPlanillaPartidoJugadorSystem().save(ppj);
      } catch (error) {
        if (!(error instanceof XhrRequestError && error.internetConnectionError())) {
          courier.messageError(error);
        }
      }
    }
  };

  const teamName =
    showCambioCamisetaTeam === 'L'
      ? form.getEquipoLocal().getClub()?.getNombre()
      : form.getEquipoVisitante().getClub()?.getNombre();

  return (
    <DialogTemplate
      showDialog={showCambioCamiseta}
      toggleShowDialog={() => {
        clear();
      }}
      title={'Cambiar N° dorsal en ' + teamName}
      onAccept={() => onAccept()}
      onCancel={() => {
        clear();
      }}
      acceptText={'Cambiar N° dorsal'}
      cancelText={'Volver'}
      minWidth={600}
      validateAccept={validateAccept}
    >
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm5">
            <TextField
              label="N° dorsal anterior"
              value={oldCamiseta}
              // type="number"
              onChange={(e, nv) =>
                nv ? nv && +nv >= 1 && +nv <= 99 && setOldCamiseta(String(nv)) : setOldCamiseta('')
              }
              errorMessage={
                !camisetaExist(+oldCamiseta) && oldCamiseta ? 'No hay ningun jugador con este dorsal' : ''
              }
              styles={{
                fieldGroup: {
                  height: 77,
                  background: !camisetaExist(+oldCamiseta) && oldCamiseta ? '#ffdbdb' : 'white',
                },
                field: { fontSize: 45, textAlign: 'center' },
              }}
            ></TextField>
          </div>
          <div className="ms-Grid-col ms-sm2 text-center mt-5">
            <Icon iconName="Sync" style={{ fontSize: 70 }}></Icon>
          </div>
          <div className="ms-Grid-col ms-sm5">
            <TextField
              label="N° dorsal nueva"
              value={newCamiseta}
              // type="number"
              onChange={(e, nv) =>
                nv ? nv && +nv >= 1 && +nv <= 99 && setNewCamiseta(String(nv)) : setNewCamiseta('')
              }
              errorMessage={
                camisetaExist(+newCamiseta) && newCamiseta ? 'Ya existe un jugador con este dorsal' : ''
              }
              styles={{
                fieldGroup: {
                  height: 77,
                  background: camisetaExist(+newCamiseta) && newCamiseta ? '#ffdbdb' : 'white',
                },
                field: { fontSize: 45, textAlign: 'center' },
              }}
            ></TextField>
          </div>
        </div>
      </div>
    </DialogTemplate>
  );
};

export default CambioCamisetaDialog;
